// Tanggal Mulai/Akhir OPSIONAL pada isian RS Jejaring Rotasi Klinik. Cermin
// _validate_rotasi_business di server.py: bila diisi, keduanya wajib & Mulai <= Akhir.
// Tanggal berformat YYYY-MM-DD (input type="date"), jadi perbandingan teks = urutan tanggal.

export function pesanTanggalRsJejaring(mulai, akhir) {
    if (!mulai && !akhir) return null;
    if (!mulai || !akhir) return "Isi Tanggal Mulai DAN Tanggal Akhir RS Jejaring, atau kosongkan keduanya";
    if (mulai > akhir) return "Tanggal Mulai RS Jejaring tidak boleh setelah Tanggal Akhir";
    return null;
}

// "2026-07-01 s/d 2026-07-10"; satu tanggal saja bila mulai = akhir ("2026-07-02"); "?" = kosong.
export function teksRentangIso(mulai, akhir) {
    if (mulai && mulai === akhir) return mulai;
    return `${mulai || "?"} s/d ${akhir || "?"}`;
}

import { lintasBulanDiizinkan } from "@/lib/kalenderRotasi";

// Lintas bulan pada dialog Edit Peserta (Stase RSCM / Stase Luar): cermin _tolak_lintas_bulan_dialog di server.
// aturan = GET /rotasi-klinik/aturan (null = belum termuat -> server yang menilai). lama = [mulai, akhir] tersimpan
// saat edit: tanggal yang tidak diubah tidak dinilai (dokumen lama yang sudah melintasi batas tetap bisa diubah).
export function pesanLintasBulanDialog(mulai, akhir, aturan, lama = null) {
    if (!aturan || !mulai || !akhir || mulai > akhir) return null;
    if (lama && lama[0] === mulai && lama[1] === akhir) return null;
    return lintasBulanDiizinkan(mulai, akhir, aturan.batas_lintas_bulan) ? null : aturan.pesan_lintas_bulan;
}

// Urutan Tanggal Mulai/Akhir Stase & Jaga di dialog Edit Peserta > Rotasi Klinik. Cermin
// _validate_rotasi_business: hanya dinilai bila keduanya diisi (tanggal tetap opsional).
export function pesanUrutanTanggal(mulai, akhir, label) {
    if (mulai && akhir && mulai > akhir) return `Tanggal Mulai ${label} tidak boleh setelah Tanggal Akhir ${label}`;
    return null;
}

// Baris tanggal di daftar segmen: data lama tanpa tanggal RS Jejaring tetap tampil seperti semula.
export function teksTanggalSegmen(r) {
    if (r.is_rs_jejaring && (r.tanggal_mulai_rs_jejaring || r.tanggal_akhir_rs_jejaring)) {
        return teksRentangIso(r.tanggal_mulai_rs_jejaring, r.tanggal_akhir_rs_jejaring);
    }
    return teksRentangIso(r.tanggal_mulai_stase, r.tanggal_akhir_stase);
}
